import React, { Component } from 'react';
import styled from 'styled-components';

const WrapDiv = styled.div`
  position: relative;
  & button {
    box-shadow: none;
    text-shadow: none;
    cursor: pointer;
  }
`;

const ToggleButton = styled.button`
  width: 100%;
  min-width: ${(props) => props.$width || 'auto'};
  height: ${(props) => props.$height || '38px'};
  background-color: #ffffff;
  color: #1E2228;
  font-size: 14px;
  font-weight: 400;
  border-radius: 8px;
  padding: 13px 35px 13px 15px;
  margin: 0px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid ${(props) => (props.open ? '#1B49EA' : props.error ? '#E74C3C' : '#c9c9c9')};
  display: flex;
  align-items: center;
  text-align: left;
  &:after {
    content: '';
    position: absolute;
    z-index: 0;
    right: 15px;
    border-width: ${(props) => (props.open ? '0px 5px 5px 5px' : '5px 5px 0px 5px')};
    border-color: ${(props) =>
      props.open
        ? 'transparent transparent #A1A1A1 transparent'
        : '#A1A1A1 transparent transparent transparent'};
    border-style: solid;
  }
  & div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const SearchWrap = styled.div`
  position: relative;
  width: 100%;
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    right: 15px;
    top: 50%;
    margin-top: -2px;
    border-width: 0px 5px 5px 5px;
    border-color: transparent transparent #A1A1A1 transparent;
    border-style: solid;
    pointer-events: none;
  }
`;

const SearchField = styled.input`
  width: 100%;
  min-width: ${(props) => props.$width || 'auto'};
  height: ${(props) => props.$height || '38px'};
  background-color: #ffffff;
  color: #1E2228;
  font-size: 14px;
  font-weight: 400;
  border-radius: 8px;
  padding: 13px 35px 13px 15px;
  margin: 0px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #1B49EA;
  outline: none;
`;

const List = styled.div`
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 4;
  border-radius: 8px;
  border: 1px solid #E6E6E6;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 4px;
`;

const ListItem = styled.button`
  width: 100%;
  background-color: #ffffff;
  color: #1E2228;
  font-size: 14px;
  border: none;
  border-bottom: 1px solid #E6E6E6;
  padding: 10px 15px;
  margin: 0px;
  display: flex;
  font-weight: ${(props) => (props.active ? '700' : 'normal')};
  white-space: nowrap;
  text-align: left;
  &:hover {
    background-color: #f6f6f6;
  }
  &:last-child {
    border-bottom: none;
  }
`;

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isListOpen: false,
      searchText: '',
    }
    this.wrapperRef = React.createRef();
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.close();
    }
  }

  close = () => {
    if (this.state.isListOpen === true) {
      this.setState({ isListOpen: false, searchText: '' });
    }
  }

  open = () => {
    if (this.state.isListOpen === false) {
      this.setState({ isListOpen: true }, () => {
        if (this.props.searchable && this.searchInputRef.current) {
          this.searchInputRef.current.focus();
        }
      });
    }
  }

  toggle = () => {
    if (this.state.isListOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  selectItem = (item, id) => {
    if (item === '') {
      this.setState({ headerTitle: this.props.title}, () => {
        this.props.selected('', this.props.name);
      });
    } else {
      this.setState({ headerTitle: item}, () => {
        this.props.selected(id, this.props.name);
      });
    }
    this.close();
  }

  searchFilter = (text, list, key) => {
    if (!list) return [];
    if (!text) return list;
    const filterText = text.trim().toLowerCase();
    return list.filter((element) =>
      String(element[key] || '').toLowerCase().includes(filterText)
    );
  }

  render () {
    const { isListOpen, searchText } = this.state;
    const { title, list, name, value, width, height, option, active, addAll, error, searchable } = this.props;

    let headerTitle = title;
    if (typeof active !== 'undefined' && typeof active[name] !== 'undefined') {
      if (active[name] !== '' && list && list.length > 0) {
        for (let x = 0; x < list.length; x++) {
          if (active[name] === list[x][value]) headerTitle = list[x][option];
        }
      }
    }
    const visibleList = searchable
      ? this.searchFilter(searchText, list, option)
      : list;

    const showSearchField = searchable && isListOpen;

    return (
      <WrapDiv ref={this.wrapperRef} style={{ width: width, height: height }}>
        { showSearchField ? (
          <SearchWrap>
            <SearchField
              ref={this.searchInputRef}
              type="text"
              placeholder={headerTitle !== title ? headerTitle : 'Search...'}
              value={searchText}
              onChange={(e) => this.setState({ searchText: e.target.value })}
              $width={width}
              $height={height}
            />
          </SearchWrap>
        ) : (
          <ToggleButton
            type="button"
            onClick={this.toggle}
            open={isListOpen}
            error={error}
            $width={width}
            $height={height}
            style={{ color: headerTitle === title ? '#7b7b7b' : '#1E2228' }}
          >
            <div>{headerTitle}</div>
          </ToggleButton>
        )}
        { isListOpen && (
          <List>
            { typeof addAll !== 'undefined' && addAll === true && !searchText ?
              <ListItem
                key={`all_${name}`}
                type="button"
                onClick={() => this.selectItem('', '')}
              >
                All
              </ListItem>
            : ''
            }
            { visibleList && visibleList.length > 0 && visibleList.map((item, itemIndex) => {
              let isActive = false;
              if (typeof active !== 'undefined' && typeof active[name] !== 'undefined' && active[name] === item[value]) {
                isActive = true;
              }
              return (
                <ListItem
                  key={`${item[option]}_${itemIndex}`}
                  type="button"
                  onClick={() => this.selectItem(item[option], item[value])}
                  active={isActive}
                >
                  {item[option]}
                </ListItem>
              )
            })}
            { searchable && visibleList && visibleList.length === 0 ?
              <ListItem as="div" style={{ color: '#7b7b7b', cursor: 'default' }}>
                No matches
              </ListItem>
            : null }
          </List>
        )}
      </WrapDiv>
    );
  }
}

export default Dropdown;
